













































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppPhoneInput from '@/components/AppPhoneInput.vue'
import AppSelector from '@/components/AppSelector.vue'
import { IContactInfoInput } from '@/modules/Contact/interfaces/contact-form'
import { states } from '@/utils/us_states'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppPhoneInput
  }
})
export default class ContactFormInfo extends Vue {
  @Prop({ type: Object as () => IContactInfoInput }) value!: IContactInfoInput

  states = states

  copyMailingAddressToBilling () {
    this.value.otherAddressStreet = this.value.mailingAddressStreet
    this.value.otherAddressCity = this.value.mailingAddressCity
    this.value.otherAddressStateIdx = this.value.mailingAddressStateIdx
    this.value.otherAddressCountry = this.value.mailingAddressCountry
    this.value.otherAddressPostalCode = this.value.mailingAddressPostalCode
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
